/**
 * Campaign Teaser – mobile video play button.
 *
 * Autoplay with `muted` + `playsinline` works on most mobile browsers,
 * but some block it (e.g. data-saver mode, low-power mode on iOS).
 * This script shows a custom play button on mobile (<768 px) whenever
 * the video is not playing, and hides it as soon as playback starts.
 */

(function () {
	"use strict";

	/**
	 * @param {HTMLElement} container - .teaser-video wrapper element
	 */
	function initTeaserVideo(container) {
		var video = container.querySelector("video");
		var playBtn = container.querySelector(".teaser-video__play-btn");

		if (!video || !playBtn) return;

		function markPlaying() {
			container.classList.add("teaser-video--playing");
		}

		function markPaused() {
			container.classList.remove("teaser-video--playing");
		}

		// Attempt autoplay; if the browser blocks it, reveal the play button.
		var autoplayPromise = video.play();
		if (autoplayPromise !== undefined) {
			autoplayPromise.then(markPlaying).catch(markPaused);
		} else {
			// Older browsers return undefined – check state directly.
			if (!video.paused) markPlaying();
		}

		video.addEventListener("play", markPlaying);
		video.addEventListener("pause", markPaused);

		playBtn.addEventListener("click", function () {
			video.play();
		});
	}

	function init() {
		document.querySelectorAll(".teaser-video").forEach(function (container) {
			initTeaserVideo(container);
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
